import { FileAudio, FileVideo } from 'lucide-react';
import type { MediaBlock } from '../chat-content';

export function MediaBlockRenderer({ block }: { block: MediaBlock }) {
  if (block.mediaType === 'image') {
    return (
      <img
        src={block.url}
        alt={block.altText ?? ''}
        className="max-h-64 max-w-full rounded-lg object-contain"
        loading="lazy"
      />
    );
  }

  if (block.mediaType === 'video') {
    return (
      <div className="overflow-hidden rounded-lg border border-border">
        <div className="flex items-center gap-2 border-b border-border bg-muted/60 px-3 py-1.5">
          <FileVideo className="size-3.5 text-muted-foreground" />
          <span className="text-xs text-muted-foreground truncate">{block.altText ?? 'Video'}</span>
        </div>
        {/* biome-ignore lint/a11y/useMediaCaption: chat media blocks render user-supplied content without guaranteed caption tracks */}
        <video
          src={block.url}
          controls
          className="max-h-64 w-full"
          aria-label={block.altText ?? 'Video'}
        />
      </div>
    );
  }

  if (block.mediaType === 'audio') {
    return (
      <div className="overflow-hidden rounded-lg border border-border">
        <div className="flex items-center gap-2 border-b border-border bg-muted/60 px-3 py-1.5">
          <FileAudio className="size-3.5 text-muted-foreground" />
          <span className="text-xs text-muted-foreground truncate">{block.altText ?? 'Audio'}</span>
        </div>
        <div className="px-3 py-2">
          {/* biome-ignore lint/a11y/useMediaCaption: chat media blocks render user-supplied content without guaranteed caption tracks */}
          <audio
            src={block.url}
            controls
            className="w-full"
            aria-label={block.altText ?? 'Audio'}
          />
        </div>
      </div>
    );
  }

  return null;
}
